module.exports = __webpack_public_path__ + "img/establishment.d8e26c2c.svg";